import * as React from 'react';

import * as styles from './CollapsedList.css';
import { ShowMoreButton } from '../ShowMoreButton';

export interface ICollapsedListProps {
  list: React.ReactNode;
  expandable: boolean;
  onExpand(): void;
}

export const CollapsedList: React.FC<ICollapsedListProps> = ({ list, expandable, onExpand }) => {
  return (
    <>
      {list}
      {expandable && (
        <div className={styles['button']}>
          <ShowMoreButton onClick={onExpand} />
        </div>
      )}
    </>
  );
};
